import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { UnsuccessfulReasonDto } from "./listCancelReasons";

export type CancelRequestRequest = {
  requestId: string;
  cancelReason: UnsuccessfulReasonDto | undefined;
  cancelNotes: string;
};

export type CancelRequestResponse = {
  successful: boolean;
};

export const cancelRequest = async (request: CancelRequestRequest) => {
  const response = await executeApiRequest(
    () => axios.post<CancelRequestResponse>("/requests/cancel", request, { withCredentials: true }),
    false
  );
  return response?.data;
};
